export const CONSTRUCTION_AUTODESK_URL = 'https://construction.autodesk.com';

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
};

export const SUBSCRIPTION_TYPES = {
  TRIAL: 'trial',
  PAID: 'paid',
};

export const COLLABORATE_EXTERNAL_KEYS = {
  COLLABORATE: 'TRIAL-BIMCOLL',
  COLLABORATE_PRO: 'TRIAL-COLLRP',
};

export const EVENTS = {
  OPEN: 'licensing.trial_modal.open',
};

export const MAX_TRIAL_DAYS = 30;

export const EXPIRED_TRIAL_MESSAGE_MAX_ACTIVE_DAYS = 5;

const AutodeskPayUserIdStg = '0199a13b-fcd0-7d46-8caf-0ad7e9acada7';
const AutodeskPayUserIdProd = '48bca3fa-29bc-4f77-b9f3-7bfa7bd9e792';

export const AUTODESK_PAY_SCRIPT_URLS = {
  QA: `https://sdk.checkout-stg.autodesk.com/autodesk-pay/main.js?clientId=${AutodeskPayUserIdStg}`,
  STAGING: `https://sdk.checkout-stg.autodesk.com/autodesk-pay/main.js?clientId=${AutodeskPayUserIdStg}`,
  PRODUCTION: `https://sdk.checkout-prd.autodesk.com/autodesk-pay/main.js?clientId=${AutodeskPayUserIdProd}`,
} as const;

export const AUTODESK_PAY_CLIENT_IDS = {
  QA: AutodeskPayUserIdStg,
  STAGING: AutodeskPayUserIdStg,
  PRODUCTION: AutodeskPayUserIdProd,
} as const;

export const AUTODESK_PAY_FORGE_CLIENT_ID = 'feftgshtserfa345643645eytgs';

export const AUTODESK_PAY_SCRIPT_ELEMENT_ID = 'autodesk-pay-sdk';
